import { aBasisFooter } from '../components/basisFooter';
import { aBasisIcon } from '../components/basisIcon';
import { aBasisNavigation } from '../components/basisNavigation';
import { aBasisNavigationMobile } from '../components/basisNavigationMobile';
import { aBasisSocialMedia } from '../components/basisSocialMediaIcon';
import { aBlockEmbed } from '../components/blockIframe';
import { aButton } from '../components/button';
import { aGrid } from '../components/grid';
import { aHeader } from '../components/basisHeader';
import { aSearch } from '../components/basisSuche';
import { aSearchResults } from '../components/basisSuchergebnisse';
import { basisCookieConsentNotice } from '../components/basisCookieConsentNotice';
import { basisTextReplacements } from '../components/basisTextReplacements';
import { blockMediaBig } from '../components/blockMediaBig';
import { blockMediaSmall } from '../components/blockMediaSmall';
import { initDelayedAnimations } from './animations';
import { initViewportRelatedAnimations } from './animations';
import { lazyLoading } from './lazyLoading';
import { blockNewsArchive } from '../components/blockNewsArchive';
import { blockAccordion } from '../components/blockAccordion';
import { blockFaq } from '../components/blockFaq';
import { blockFaqSearch } from '../components/blockFaqSearch';
import { blockServices } from '../components/blockServices';
import { blockChart } from '../components/blockChart';
import { blockBlogArchive } from '../components/blockBlogArchive';
import { blockImageInteractive } from '../components/blockImageInteractive';
import { basisMaps } from '../components/basisMaps';
import { blockTable } from '../components/blockTable';
import { basisForm } from '../components/basisForm';
import { aInput } from '../components/input';
import { blockTariffCalculator } from '../components/blockTariffCalculator';
import { blockFibreChecker } from '../components/blockFibreChecker';
import { basisVideoPlayer } from '../components/basisVideoPlayer';
import { blockPressReleasesArchive } from '../components/blockPressReleasesArchive';
import { matomoTracking } from '../components/basisMatomo';
import { a11y } from './a11y';
import { lockHeaderOnSmoothScroll } from './smoothScrolling';
import { blockJobs } from '../components/blockJobs';
import { basisJobTeaser } from '../components/basisJobTeaser';
import { aA11yShortcut } from '../components/a11y-shortcut';
import { heroMediaBig } from '../components/heroMediaBig';
import { heroMediaSmall } from '../components/heroMediaSmall';
import { blockNetworkExpansionMap } from '../components/blockNetworkExpansionMap';

export const init = () => {
  aBasisFooter();
  aBasisIcon();
  aBasisNavigation();
  aBasisNavigationMobile();
  aBasisSocialMedia();
  aBlockEmbed();
  aButton();
  aGrid();
  aHeader();
  aInput();
  aA11yShortcut();
  aSearch();
  aSearchResults();
  blockMediaBig();
  blockMediaSmall();
  blockNewsArchive();
  blockAccordion();
  blockFaq();
  blockFaqSearch();
  blockServices();
  blockChart();
  blockBlogArchive();
  blockPressReleasesArchive();
  blockImageInteractive();
  basisMaps();
  blockNetworkExpansionMap();
  blockTable();
  basisForm();
  blockTariffCalculator();
  blockFibreChecker();
  basisVideoPlayer();
  lockHeaderOnSmoothScroll();
  blockJobs();
  basisJobTeaser();
  heroMediaBig();
  heroMediaSmall();

  /** Animations */
  initDelayedAnimations();
  initViewportRelatedAnimations();

  /** Execute last */
  lazyLoading();
  basisTextReplacements();
  basisCookieConsentNotice();
  matomoTracking();
  a11y();
};
